import { Preferences } from "@capacitor/preferences";

// Token persistence. Capacitor Preferences gives one API across platforms: on
// the web it's backed by localStorage, on iOS/Android by native preferences —
// so the same code persists the JWT pair in the browser and on mobile.

const ACCESS_KEY = "fortress.accessToken";
const REFRESH_KEY = "fortress.refreshToken";

export interface StoredTokens {
  accessToken: string;
  refreshToken: string;
}

export async function getStoredTokens(): Promise<StoredTokens | null> {
  const [{ value: accessToken }, { value: refreshToken }] = await Promise.all([
    Preferences.get({ key: ACCESS_KEY }),
    Preferences.get({ key: REFRESH_KEY }),
  ]);
  if (!accessToken || !refreshToken) return null;
  return { accessToken, refreshToken };
}

export async function setStoredTokens(tokens: StoredTokens): Promise<void> {
  await Promise.all([
    Preferences.set({ key: ACCESS_KEY, value: tokens.accessToken }),
    Preferences.set({ key: REFRESH_KEY, value: tokens.refreshToken }),
  ]);
}

export async function clearStoredTokens(): Promise<void> {
  await Promise.all([
    Preferences.remove({ key: ACCESS_KEY }),
    Preferences.remove({ key: REFRESH_KEY }),
  ]);
}
